import DrillToTooltipPart, { TooltipDrillData } from 'components/report-content/tooltip/DrillToTooltipPart';
import { Box, Stack } from '@mui/material';
import styles from 'components/report-content/styles';
import { ReportTooltipProps } from 'components/report-content/tooltip';
import type { ComponentSettingsLineChart } from '@report-content';

export default function LineChartTooltip({
    point,
    settings,
    contentSettings,
    closeComponent,
}: ReportTooltipProps<ComponentSettingsLineChart>) {
    const drillData: Array<TooltipDrillData> = [
        {
            field: settings.x_axis.field,
            value: point.name,
        },
        {
            field: 'snapshot_date',
            value: contentSettings.measurement_time ?? '',
        },
    ];

    return (
        <Stack direction="column">
            {(point.key?.x_f?.length ?? 0 > 0) && <Box>{point.key.x_f}</Box>}
            <Stack
                direction="row"
                justifyContent={'space-between'}
                sx={{ ...styles.sectionWrapper, paddingLeft: 0, paddingRight: 0, paddingTop: 0, height: 29 }}
            >
                <Stack direction={'row'}>
                    <Box
                        style={{ color: String(point.color) }}
                        dangerouslySetInnerHTML={{ __html: (point?.key?.name_f ?? '') + ':&nbsp;' }}
                    />
                    <Box>{point?.key?.y_f ?? ''}</Box>
                </Stack>
                <Box>{closeComponent}</Box>
            </Stack>
            <DrillToTooltipPart contentSettings={contentSettings} data={drillData} settings={settings} />
        </Stack>
    );
}
